import { Text, Heading, Flex } from "@radix-ui/themes";
import { useSurveyStore } from "@store/survey";
import { Trans } from "@lingui/macro";
import { useEffect, useState } from "react";

export default function ClusterSummary() {
  const { selectedSchool: feature } = useSurveyStore();

  const [schoolsList, setSchoolsList] = useState([]);

  useEffect(() => {
    if (!feature) return;
    const schools = feature?.properties?.schools;
    const schoolsList = schools
      ?.slice(1, -1)
      .split(",")
      .map((school) => school.replace(/"/g, ""));
    setSchoolsList(schoolsList);
  }, [feature]);

  if (feature?.source !== "merger_clusters") return;

  return (
    <Flex gap="1" direction="column">
      <Heading as="h2" size="4">
        {feature?.properties?.Cluster}
      </Heading>
      <Text size="2" color="gray">
        <Trans id="ClusterSummary.schools">Schools</Trans>
      </Text>
      <ul
        style={{
          marginBlockStart: 0,
          marginBlockEnd: 0,
          paddingInlineStart: "var(--popover-content-padding)",
        }}
      >
        {schoolsList.map((school) => (
          <li key={school}>
            <Text size="2">{school}</Text>
          </li>
        ))}
      </ul>
    </Flex>
  );
}
